import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';

import { TicketsService } from '@app/services/tickets.service';

import {
  loadServiceSummaryDetails,
  loadServiceSummaryDetailsFailed,
  loadServiceSummaryDetailsSuccess,
  loadServiceSummaryStats,
  loadServiceSummaryStatsFailed,
  loadServiceSummaryStatsSuccess,
} from './service.actions';

@Injectable()
export class ServiceEffects {
  constructor(private actions$: Actions, private ticketsService: TicketsService) {}

  loadServiceSummaryStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadServiceSummaryStats),
      mergeMap(action =>
        this.ticketsService.getServiceSummaryStats(action.filter).pipe(
          map(stats => loadServiceSummaryStatsSuccess({ stats })),
          catchError(error => of(loadServiceSummaryStatsFailed({ error })))
        )
      )
    )
  );

  loadServiceSummaryDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadServiceSummaryDetails),
      mergeMap(action =>
        this.ticketsService.getServiceSummaryDetails(action.filter).pipe(
          map(details => loadServiceSummaryDetailsSuccess({ details })),
          catchError(error => of(loadServiceSummaryDetailsFailed({ error })))
        )
      )
    )
  );
}
